export default "__VITE_ASSET__1c1b6c3f__"